/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Notes_Delete_Note_TitleInputs */

const en_mobile_notes_delete_note_title = /** @type {(inputs: Mobile_Notes_Delete_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete note`)
};

const es_mobile_notes_delete_note_title = /** @type {(inputs: Mobile_Notes_Delete_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar nota`)
};

/**
* | output |
* | --- |
* | "Delete note" |
*
* @param {Mobile_Notes_Delete_Note_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_notes_delete_note_title = /** @type {((inputs?: Mobile_Notes_Delete_Note_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Notes_Delete_Note_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_notes_delete_note_title(inputs)
	return en_mobile_notes_delete_note_title(inputs)
});